<template>
  <div class="uc-Exam-box">
    <section class="g-headerExam">
      <div class="container">
        <div class="row">
          <div class="col-24 box">
            <router-link to="/" class="logo"
              ><img :src="$store.getters.user.company_logo"
            /></router-link>
            <div class="title">答题情况统计</div>
          </div>
        </div>
      </div>
    </section>
    <div class="g-headerExamSpace"></div>

    <section class="container-fluid g-ExamPercentBox">
      <div class="container">
        <div class="col-24 box">
          <div class="title">{{ model.paper_name }}</div>
        </div>
      </div>
    </section>
    <div class="g-ExamPercentBoxSpace"></div>

    <section class="container-fluid uc-bg g-examInfo">
      <div class="container">
        <div class="box">
          <div class="item">
            <span class="txt">考 生 姓 名：</span
            >{{ $store.getters.user.first_name }}
          </div>
          <div class="item">
            <span class="txt">答题时间始：</span>{{ model.start_time }}
          </div>
          <div class="item">
            <span class="txt">答题时间止：</span>{{ model.end_time }}
          </div>
          <div class="item">
            <span class="txt">答 题 时 间：</span>{{ model.duration }}分钟
          </div>
          <div class="item">
            <span class="txt">考 生 耗 时：</span
            ><span v-if="model.spent_time >= 60"
              >{{ parseInt(model.spent_time / 60) }}分钟</span
            ><span v-if="model.spent_time % 60 > 0"
              >{{ model.spent_time % 60 }}秒</span
            >
          </div>
          <div class="item">
            <span class="txt">试 卷 总 分：</span>{{ model.total_score }}分
          </div>
          <div class="item">
            <span class="txt">通 过 分 数：</span>{{ model.pass_score }}分
          </div>
          <div class="item">
            <span class="txt">考 生 成 绩：</span>{{ model.user_score }}分
          </div>
          <div class="item">
            <span class="txt">标准题得分：</span>{{ model.auto_score }}分
          </div>
          <div class="item">
            <span class="txt">手工题得分：</span
            >{{ model.manual_score ? model.manual_score + '分' : '无' }}
          </div>
          <div class="item">
            <span class="txt">评 分 方 式：</span
            >{{ model.score_way == 1 ? '自动' : '手动' }}
          </div>
          <div class="item">
            <span class="txt">通 过 考 试：</span
            >{{ model.is_pass ? '通过' : '未通过' }}
          </div>
        </div>
      </div>
    </section>

    <section class="container-fluid uc-bg uc-StatisticsList">
      <div class="container">
        <div class="box">
          <div class="title">知识点统计</div>
          <div class="sub-title">自动评分部分</div>
          <table>
            <tr>
              <th>序号</th>
              <th>知识点</th>
              <th>试题数</th>
              <th>答对数</th>
              <th>正确率</th>
            </tr>
            <tr v-for="(item, index) in model.data[0]" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.item1 }}</td>
              <td>{{ item.item2 }}</td>
              <td>{{ item.item3 }}</td>
              <td>
                <div class="percent">
                  <span class="per" :style="`width: ${item.item4}`"></span>
                </div>
                <i class="number uc-blue">{{ item.item4 }}</i>
              </td>
            </tr>
            <tr v-if="model.data[0].length == 0">
              <td colspan="5" style="text-align: center">暂无数据</td>
            </tr>
            <tr class="total" v-if="model.total_data[0]">
              <td></td>
              <td>自动评分总计</td>
              <td>{{ model.total_data[0].item1 }}</td>
              <td>{{ model.total_data[0].item2 }}</td>
              <td>
                <div class="percent">
                  <span
                    class="per"
                    :style="`width: ${model.total_data[0].item3};`"
                  ></span>
                </div>
                <i class="number">{{ model.total_data[0].item3 }}</i>
              </td>
            </tr>
          </table>

          <div class="sub-title">人工评分部分</div>
          <table>
            <tr>
              <th>序号</th>
              <th>知识点</th>
              <th>总分数</th>
              <th>得分数</th>
              <th>得分率</th>
            </tr>
            <tr v-for="(item, index) in model.data[1]" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.item1 }}</td>
              <td>{{ item.item2 }}</td>
              <td>{{ item.item3 }}</td>
              <td>
                <div class="percent">
                  <span class="per" :style="`width: ${item.item4}`"></span>
                </div>
                <i class="number uc-blue">{{ item.item4 }}</i>
              </td>
            </tr>
            <tr v-if="model.data[1].length == 0">
              <td colspan="5" style="text-align: center">暂无数据</td>
            </tr>
            <tr class="total" v-if="model.total_data[1]">
              <td></td>
              <td>人工评分总计</td>
              <td>{{ model.total_data[1].item1 }}</td>
              <td>{{ model.total_data[1].item2 }}</td>
              <td>
                <div class="percent">
                  <span
                    class="per"
                    :style="`width: ${model.total_data[1].item3};`"
                  ></span>
                </div>
                <i class="number">{{ model.total_data[1].item3 }}</i>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div class="container">
        <div class="box">
          <div class="title">题目类型统计</div>
          <div class="sub-title">自动评分部分</div>
          <table>
            <tr>
              <th>序号</th>
              <th>知识点</th>
              <th>试题数</th>
              <th>答对数</th>
              <th>正确率</th>
            </tr>
            <tr v-if="model.data[2].length == 0">
              <td colspan="5" style="text-align: center">暂无数据</td>
            </tr>
            <tr v-for="(item, index) in model.data[2]" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.item1 }}</td>
              <td>{{ item.item2 }}</td>
              <td>{{ item.item3 }}</td>
              <td>
                <div class="percent">
                  <span class="per" :style="`width: ${item.item4}`"></span>
                </div>
                <i class="number uc-blue">{{ item.item4 }}</i>
              </td>
            </tr>
            <tr class="total" v-if="model.total_data[2]">
              <td></td>
              <td>自动评分总计</td>
              <td>{{ model.total_data[2].item1 }}</td>
              <td>{{ model.total_data[2].item2 }}</td>
              <td>
                <div class="percent">
                  <span
                    class="per"
                    :style="`width: ${model.total_data[2].item3};`"
                  ></span>
                </div>
                <i class="number">{{ model.total_data[2].item3 }}</i>
              </td>
            </tr>
          </table>

          <div class="sub-title">人工评分部分</div>
          <table>
            <tr>
              <th>序号</th>
              <th>知识点</th>
              <th>总分数</th>
              <th>得分数</th>
              <th>得分率</th>
            </tr>
            <tr v-if="model.data[3].length == 0">
              <td colspan="5" style="text-align: center">暂无数据</td>
            </tr>
            <tr v-for="(item, index) in model.data[3]" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.item1 }}</td>
              <td>{{ item.item2 }}</td>
              <td>{{ item.item3 }}</td>
              <td>
                <div class="percent">
                  <span class="per" :style="`width: ${item.item4}`"></span>
                </div>
                <i class="number uc-blue">{{ item.item4 }}</i>
              </td>
            </tr>
            <tr class="total" v-if="model.total_data[3]">
              <td></td>
              <td>人工评分总计</td>
              <td>{{ model.total_data[3].item1 }}</td>
              <td>{{ model.total_data[3].item2 }}</td>
              <td>
                <div class="percent">
                  <span
                    class="per"
                    :style="`width: ${model.total_data[3].item3};`"
                  ></span>
                </div>
                <i class="number">{{ model.total_data[3].item3 }}</i>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </section>

    <section
      class="uc-fixedAnswerSheetSideList"
      :class="showSide ? 'on' : ''"
      v-if="model.history_records.length > 1"
    >
      <button class="btns" hover-class="none" @click="btnShowSideList">
        历史成绩
      </button>
      <div class="title">
        我的成绩
        <div class="r">
          通过分数: <i class="uc-blue">{{ model.pass_score }}分</i>
        </div>
      </div>
      <div class="list">
        <div
          class="item"
          v-for="(item, index) in model.history_records"
          :key="index"
        >
          <div class="number">{{ item.user_score }}分</div>
          <div class="time">{{ item.start_time }}</div>
          <span class="uc-tag green-light" v-if="item.is_pass">已通过</span>
          <span class="uc-tag red-light" v-else>未通过</span>
          <router-link
            :to="{ name: 'ExamStatistics', params: { id: item.answer_id } }"
            class="uc-btn blue"
            >查看详情</router-link
          >
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ExamStatistics',
  components: {},
  data() {
    return {
      showSide: true,
      query: {
        id: this.$route.params.id,
      },
      model: {
        data: [[], [], [], []],
        total_data: [[], [], [], []],
        history_records: [],
      },
    };
  },
  watch: {
    $route(to, from) {
      // 对路由变化作出响应...
      this.query.id = to.params.id;
      this.loadData();
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.getStatistics();
    },
    async getStatistics() {
      const response = await this.$api.exam.getStatistics(this.query);
      const { code, data } = response.data;
      this.model = data;
    },
    btnShowSideList() {
      this.showSide = !this.showSide;
    },
  },
};
</script>
